import { Button, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AddCircle from '@mui/icons-material/AddCircle';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../../../language/keys';
import { GET_ACADEMICS_FROM } from '../../../../../consts';
import { style } from './style';

type NoAcademicsProps = {
    academicsGetFrom: string,
    onOpenCreateNewCompanyModal?: () => void,
    listAutocomplete:Academic[],
    valueName: string,
}

export const NoAcademics = ({
  academicsGetFrom,
  onOpenCreateNewCompanyModal,
  listAutocomplete,
  valueName,
}: NoAcademicsProps): JSX.Element => {
  const { t: translate } = useTranslation();

  if (valueName.trim() !== '' &&
  academicsGetFrom !== '' &&
  listAutocomplete?.length === 0) {
    return (
      <div style={ style.noOptions }>
        <ErrorOutlineIcon />
        <Typography style={ style.noOptionsText }>
          {academicsGetFrom === GET_ACADEMICS_FROM.LINKEDIN ?
            translate(STRING_KEYS.ACADEMIC_NOT_FOUND_LINKEDIN) :
            translate(STRING_KEYS.ACADEMIC_NOT_FOUND_DB, {
              academicName: valueName,
            })}
        </Typography>
        {academicsGetFrom === GET_ACADEMICS_FROM.DB && (
          <Button
            size="large"
            style={ style.noOptionsButton }
            startIcon={ <AddCircle color="primary" /> }
            onClick={ () => onOpenCreateNewCompanyModal && onOpenCreateNewCompanyModal() }
          >{translate(STRING_KEYS.ADD_MANUALLY)}
          </Button>
        )}
      </div>
    );
  }

  return <>{translate(STRING_KEYS.NO_OPTIONS_ACADEMIC_PLACEHOLDER)}</>;
};

NoAcademics.defaultProps = {
  onOpenCreateNewCompanyModal: undefined,
};
